module.exports = __webpack_public_path__ + "img/b_intro_4_en.47dc89b.png";